import styled, { css } from 'styled-components';
import { darken } from 'polished';

import media from 'styled-media-query';
// import banner from '~/assets/banner.jpeg';

import { Media } from '../../styles/constants';

export const Container = styled.div`
  width: 100%;
  background: #f2f4f7;
  /* height: 100vh; */
  min-height: 100vh;
  overflow: auto;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;

  span.inclusive {
    margin: 0 10px;
    min-width: 95px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    color: #F4F5F7;
    background-color: #5243AA;
    font-family: Roboto;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
  }

  h3 {
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 23px;
    text-align: justify;
    color: #667085;
  }

  a.back {
    width: 180px;
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
    text-decoration: none;
    border: 1px solid #36397a;
    margin-top: 60px;
    margin-bottom: 60px;
    :hover {
      background: darken(0.1, '#475467');
    }
    color: #475467;
    @media only screen and (max-width: 950px) {
      margin-top: 25px;
      width: 100%;
    }

    svg {
      width: 10px;
      margin-right: 8px;
    }
  }
`;

export const Card = styled.div`
  width: 100%;
  min-height: 200px;
  max-width: 980px;
  background: #ffffff;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.05);
  border-radius: 6px;
  margin-top: 26px;
  padding: 19px 24px;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
  position: relative;
  gap: 26px;
  margin-bottom: 26px;

  .container-btn-mobile {
    display: none;
  }

  svg {
    width: 16px;
  }

  .container-left {
    width: 100%;
  }

  .container-right {
    width: 100%;
  }

  @media only screen and (max-width: 950px) {
    width: 95%;
    flex-direction: column;

    .container-btn-desktop {
      display: none;
    }

    .container-btn-mobile {
      display: flex;
    }

    .container-left {
      width: 100%;
    }

    .container-right {
      width: 100%;
    }
  }
`;

export const Title = styled.h2`
  gap: 16px;
  font-style: normal;
  font-weight: 700;
  font-size: 26px;
  line-height: 30px;
  color: #475467;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;

  @media only screen and (max-width: 950px) {
    .pcd {
      position: absolute;
      right: 0;
    }
  }
`;

export const Row = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;

  h3 {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: #667085;

    svg {
      width: 16px;
      margin-right: 8px;
    }
  }
  @media only screen and (max-width: 950px) {
    flex-direction: column;

    a.link-social {
      margin-top: 12px;
    }

    svg {
      width: 22px;
      margin-right: 8px;
    }

    h3 {
      font-style: normal;
      font-weight: 600;
      font-size: 12px;
      line-height: 18px;
      text-align: center;
      color: #667085;
    }

    div.div-info-vacancy {
      width: 100%;
      flex-wrap: wrap;
      justify-content: center !important;
      align-items: center !important;
      display: flex;
    }
  }

  a.sendcv {
    background: ${props => props.primaryColor || '#36397A'};
    width: 180px;
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
    text-decoration: none;
    :hover {
      background: ${props => darken(0.1, props.primaryColor || '#36397A')};
    }
    color: #fff;
    @media only screen and (max-width: 950px) {
      margin-top: 25px;
      width: 100%;
    }
  }
`;

export const Tag = styled.div`
  h3 {
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 24px;
    text-align: center;
    color: #475467;

    svg {
      width: 24px;
      margin-right: 8px;
      color: #475467;
    }
  }
  @media only screen and (max-width: 950px) {
    h3 {
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 18px;
      text-align: center;
      color: #ffffff;
      width: 55px;
    }
  }
`;

export const TitleItems = styled.h4`
  font-weight: 400;
  font-size: 16px;
  line-height: 18px;
  color: #667085;
  svg {
    color: #667085;
    margin-right: 12px;
  }
  @media only screen and (max-width: 950px) {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: #667085;
    flex-wrap: nowrap;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const DescriptionsText = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 37px;
  color: #667085;
  font: 18px/32px;
  letter-spacing: 0;

  p {
    margin: 8px 0 8px 0;
  }

  ul {
    margin: 8px;
    padding: 12px;
  }
`;

export const ModalShare = styled.div`
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: flex-start;
  justify-content: center;
  position: fixed;
  padding: 200px;
  z-index: 1;

  visibility: ${props => (props.showModalShare ? 'visible' : 'hidden')};
  &:hidden {
    visibility: hidden;
    transition-delay: 0, 0.6s;
  }
  transition: visibility 0.5s;

  .modalShareContent {
    padding: 16px;
    width: 90%;
    height: 160px;
    background: #fff;
    position: absolute;
    display: flex;
    flex-direction: column;
    justify-content: center;
    box-shadow: 4px 6px 8px -4px ${props => (props.primaryColor ? props.primaryColor : '#4c5cce')};
    top: -100em;
    ${props =>
      props.showModalShare &&
      css`
        position: absolute;
        top: 200px;
      `}
    transition: top 0.8s;
  }
`;
